// Import der Schriftarten


const $cdf4517f1880f616$var$menuBtn = document.querySelector('.hamburger');
const $cdf4517f1880f616$var$siteNav = document.querySelector('#main-nav');
const $cdf4517f1880f616$var$setMenuState = (isOpen)=>{
    $cdf4517f1880f616$var$menuBtn.setAttribute('aria-expanded', String(isOpen));
    $cdf4517f1880f616$var$menuBtn.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    document.body.classList.toggle('nav-open', isOpen);
};
$cdf4517f1880f616$var$menuBtn.addEventListener('click', ()=>{
    const isOpen = $cdf4517f1880f616$var$menuBtn.getAttribute('aria-expanded') === 'true';
    $cdf4517f1880f616$var$setMenuState(!isOpen);
});
$cdf4517f1880f616$var$siteNav.querySelectorAll('a').forEach((link)=>{
    link.addEventListener('click', ()=>{
        $cdf4517f1880f616$var$setMenuState(false);
    });
});


//# sourceMappingURL=MoritzThiem.af14719f.js.map
